import apiClient from './apiClient';

class SupportService {
    static getTicketList(data) {
        return apiClient.get('/Support', { params: data });
    }
    static createTicket(data) {
        return apiClient.post('/Support', data);
    }
    static uploadAttachment(data) {
        return apiClient.post('/Support/Attachments', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
    static getTicketDetail(data) {
        const { TicketRef } = data;
        return apiClient.get(`/Support/${TicketRef}`, { params: data });
    }
    static createTicketReply(data) {
        const { TicketRef } = data;
        return apiClient.post(`/Support/${TicketRef}`, data);
    }
    static updateTicketStatus(data) {
        const { TicketRef } = data;
        return apiClient.patch(`/Support/${TicketRef}`, data);
    }
}

export default SupportService;
